import React from "react";
import { Text as TextReactNative } from "react-native";
import { getIsRTL } from "../util";

const Text = (props: any) => {
  const onPressHandler = () => {
    props.onPress();
  };
  return (
    <TextReactNative
      style={[
        {
          fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
          textAlign: getIsRTL() ? "right" : "left",
        },
        props.style,
      ]}
      {...(props.onPress && { onPress: () => onPressHandler() })}
      {...(props.numberOfLines && { numberOfLines: props.numberOfLines })}
      {...(props.ellipsizeMode && { ellipsizeMode: props.ellipsizeMode })}
    >
      {props.children}
    </TextReactNative>
  );
};

export default Text;
